// extracted by css-extract-rspack-plugin
export default {"spinner":"CQq14X","spin":"D_3PuC","trackPath":"dlJ6iP","brandPath":"aTtLOq"};